import React, { useState } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { Car, Users, Shield, FileText, Plus, Search, Filter } from 'lucide-react';
import MatriculaInicial from './MatriculaInicial';
import TraspasoPropiedad from './TraspasoPropiedad';
import LicenciasConduccion from './LicenciasConduccion';
import Garantias from './Garantias';
import QuickTramiteModal from '../components/QuickTramiteModal';

const Tramites: React.FC = () => {
  const navigate = useNavigate();
  // const [searchTerm, setSearchTerm] = useState('');
  // const [filterType, setFilterType] = useState('all');

  const tramitesAutomotor = [
    {
      id: 'matricula-inicial',
      title: 'Matrícula Inicial de Vehículo',
      description: 'Registro de vehículos nuevos en el sistema',
      icon: Car,
      color: 'bg-blue-500',
      path: '/tramites/automotor/matricula-inicial'
    },
    {
      id: 'traspaso-propiedad',
      title: 'Traspaso de Propiedad',
      description: 'Cambio de propietario de vehículo',
      icon: Users,
      color: 'bg-green-500',
      path: '/tramites/automotor/traspaso-propiedad'
    },
    {
      id: 'duplicado-tarjeta',
      title: 'Duplicado Tarjeta Propiedad',
      description: 'Solicitud de duplicado de tarjeta',
      icon: FileText,
      color: 'bg-yellow-500',
      path: '/tramites/automotor/duplicado-tarjeta'
    },
    {
      id: 'cambio-color-servicio',
      title: 'Cambio de Color o Servicio',
      description: 'Modificación de características del vehículo',
      icon: Car,
      color: 'bg-purple-500',
      path: '/tramites/automotor/cambio-color-servicio'
    },
    {
      id: 'cambio-motor-carroceria',
      title: 'Cambio de Motor o Carrocería',
      description: 'Modificación de componentes principales',
      icon: Car,
      color: 'bg-red-500',
      path: '/tramites/automotor/cambio-motor-carroceria'
    },
    {
      id: 'cambio-placa',
      title: 'Cambio de Placa de Vehículo',
      description: 'Solicitud de cambio de placa',
      icon: Car,
      color: 'bg-indigo-500',
      path: '/tramites/automotor/cambio-placa'
    },
    {
      id: 'cancelacion-matricula',
      title: 'Cancelación de Matrícula',
      description: 'Cancelación del registro vehicular',
      icon: Shield,
      color: 'bg-gray-500',
      path: '/tramites/automotor/cancelacion-matricula'
    },
    {
      id: 'rematriculacion',
      title: 'Rematriculación',
      description: 'Reactivación de matrícula cancelada',
      icon: Car,
      color: 'bg-teal-500',
      path: '/tramites/automotor/rematriculacion'
    }
  ];

  const tramitesPersonas = [
    {
      id: 'licencias-conduccion',
      title: 'Licencias de Conducción',
      description: 'Gestión de licencias de conducción',
      icon: Users,
      color: 'bg-blue-500',
      path: '/tramites/personas/licencias-conduccion'
    },
    {
      id: 'licencia-mayoria-edad',
      title: 'Licencia por Mayoría de Edad',
      description: 'Licencia para mayores de edad',
      icon: Users,
      color: 'bg-green-500',
      path: '/tramites/personas/licencia-mayoria-edad'
    },
    {
      id: 'expedicion-tarjetas-operacion',
      title: 'Expedición Tarjetas de Operación',
      description: 'Tarjetas para vehículos de servicio público',
      icon: FileText,
      color: 'bg-yellow-500',
      path: '/tramites/personas/expedicion-tarjetas-operacion'
    }
  ];

  const tramitesGarantias = [
    {
      id: 'inscripcion-prenda',
      title: 'Inscripción de Prenda',
      description: 'Registro de garantías vehiculares',
      icon: Shield,
      color: 'bg-blue-500',
      path: '/tramites/garantias/inscripcion-prenda'
    },
    {
      id: 'levantamiento-prenda',
      title: 'Levantamiento de Prenda',
      description: 'Cancelación de garantías',
      icon: Shield,
      color: 'bg-green-500',
      path: '/tramites/garantias/levantamiento-prenda'
    }
  ];

  const tramitesOtros = [
    {
      id: 'solicitud-historiales',
      title: 'Solicitud de Historiales',
      description: 'Consulta de historiales vehiculares',
      icon: FileText,
      color: 'bg-blue-500',
      path: '/tramites/otros/solicitud-historiales'
    },
    {
      id: 'otros-tramites',
      title: 'Otros Trámites',
      description: 'Trámites especiales y adicionales',
      icon: FileText,
      color: 'bg-gray-500',
      path: '/tramites/otros/otros-tramites'
    }
  ];

  const allTramites = [
    ...tramitesAutomotor.map(t => ({ ...t, category: 'Automotor' })),
    ...tramitesPersonas.map(t => ({ ...t, category: 'Personas' })),
    ...tramitesGarantias.map(t => ({ ...t, category: 'Garantías' })),
    ...tramitesOtros.map(t => ({ ...t, category: 'Otros' }))
  ];

  // const filteredTramites = allTramites.filter(tramite => {
  //   const matchesSearch = tramite.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //                         tramite.description.toLowerCase().includes(searchTerm.toLowerCase());
  //   const matchesFilter = filterType === 'all' || tramite.category.toLowerCase() === filterType.toLowerCase();
  //   return matchesSearch && matchesFilter;
  // });

  // const handleIniciarTramite = (path: string) => {
  //   navigate(path);
  // };

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/tramites/automotor" replace />} />
      <Route path="/automotor" element={<TramitesSection title="Trámites Automotor" tramites={tramitesAutomotor} />} />
      <Route path="/personas" element={<TramitesSection title="Trámites de Personas" tramites={tramitesPersonas} />} />
      <Route path="/garantias" element={<TramitesSection title="Trámites de Garantías" tramites={tramitesGarantias} />} />
      <Route path="/otros" element={<TramitesSection title="Otros Trámites" tramites={tramitesOtros} />} />
      
      {/* Rutas específicas */}
      <Route path="/automotor/matricula-inicial" element={<MatriculaInicial />} />
      <Route path="/automotor/traspaso-propiedad" element={<TraspasoPropiedad />} />
      <Route path="/personas/licencias-conduccion" element={<LicenciasConduccion />} />
      <Route path="/garantias/*" element={<Garantias />} />
    </Routes>
  );
};

interface TramitesSectionProps {
  title: string;
  tramites: any[];
}

const TramitesSection: React.FC<TramitesSectionProps> = ({ title, tramites }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);

  const filteredTramites = tramites.filter(tramite =>
    tramite.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    tramite.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleIniciarTramite = (path: string) => {
    navigate(path);
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
          <p className="text-gray-600">Selecciona el trámite que deseas realizar</p>
        </div>
        <button 
          className="btn btn-primary"
          onClick={() => setShowModal(true)}
        >
          <Plus className="w-4 h-4 mr-2" />
          Nuevo Trámite
        </button>
      </div>

      {/* Search */}
      <div className="flex items-center space-x-4">
        <div className="flex-1 relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
          <input
            type="text"
            placeholder="Buscar trámites..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="input pl-10"
          />
        </div>
        <button className="btn btn-secondary">
          <Filter className="w-4 h-4 mr-2" />
          Filtros
        </button>
      </div>

      {/* Tramites Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredTramites.map((tramite) => (
          <div key={tramite.id} className="card p-6 hover:shadow-lg transition-shadow cursor-pointer">
            <div className="flex items-start space-x-4">
              <div className={`${tramite.color} p-3 rounded-lg`}>
                <tramite.icon className="w-6 h-6 text-white" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{tramite.title}</h3>
                <p className="text-gray-600 text-sm mb-4">{tramite.description}</p>
                <button 
                  className="btn btn-primary text-sm"
                  onClick={() => handleIniciarTramite(tramite.path)}
                >
                  Iniciar Trámite
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {filteredTramites.length === 0 && (
        <div className="text-center py-12">
          <FileText className="w-12 h-12 text-gray-400 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">No se encontraron trámites</h3>
          <p className="text-gray-600">Intenta con otros términos de búsqueda</p>
        </div>
      )}
      
      <QuickTramiteModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        tramites={tramites}
        onSelectTramite={handleIniciarTramite}
      />
    </div>
  );
};

export default Tramites;
